import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { SearchableDropdownComponent } from '@app/components/searchable-dropdown/searchable-dropdown.component';
import type { SelectOption } from '@app/types';

@Component({
  selector: 'app-integration-profile-selector',
  standalone: true,
  imports: [SearchableDropdownComponent],
  templateUrl: './integration-profile-selector.component.html',
  styleUrl: './integration-profile-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntegrationProfileSelectorComponent {
  readonly options = input.required<SelectOption[]>();
  readonly selectedValue = input<string | null>(null);
  readonly placeholder = input<string>('');
  readonly panelHorizontalAlign = input<'start' | 'end'>('start');
  /** Smaller trigger for dense headers (e.g. merchant details title row). */
  readonly triggerAppearance = input<'default' | 'minimal' | 'compact'>('default');

  @Output() readonly selectionChange = new EventEmitter<string | null>();

  onSelectionChange(value: string | number | Array<string | number> | null): void {
    if (value === null) {
      this.selectionChange.emit(null);
      return;
    }
    if (Array.isArray(value)) {
      this.selectionChange.emit(value.length > 0 ? String(value[0]) : null);
      return;
    }
    this.selectionChange.emit(String(value));
  }
}
